define([
    'text!product-detail/component/size-image-single.html',

    'css!product-detail/component/size-image-single.css'
], function(
    tpl
){
    return {
        template: tpl,
        props: {
            image: {
                type: String
            },
            bgColor: {
                type: String
            },
            bgColorDown: {
                type: String
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/size-image-single.js
// module id = 242
// module chunks = 0